import { useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BidQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const CREATE_BID_WIN_THEME_MUTATION = graphql(`
  mutation createBidWinTheme($CreateBidWinThemeInput: CreateBidWinThemeInput!) {
    createBidWinTheme(CreateBidWinThemeInput: $CreateBidWinThemeInput) {
      id
      title
      description
      sources {
        title
        id
        type
        url
        chunkNumber
        documentType
        filePath
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
        isDeleted
        citationId
      }
    }
  }
`);

export function useCreateBidWinTheme({ bidId }: { bidId: string }) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(CREATE_BID_WIN_THEME_MUTATION, {
    onSuccess: (data) => {
      queryClient.setQueryData<BidQuery>(["bid", bidId], (prevData) => {
        if (!prevData?.bid) return prevData;
        return {
          ...prevData,
          bid: {
            ...prevData.bid,
            winThemes: [...prevData.bid.winThemes, data.createBidWinTheme],
          },
        };
      });
    },
  });

  return { data: data?.createBidWinTheme, ...rest };
}
